
import React, { useEffect, useRef } from 'react';
import { CallbackProcessing } from '../investments/CallbackProcessing';
import { useSearchParams } from 'react-router-dom';
import { useVezgoContext } from '@/providers/vezgo/context/VezgoContext';
import { cleanupConnectionSuccessParams } from '@/providers/vezgo/utils/cleanup';
import { logger } from '@/services/LoggingService';
import { CallbackProcessor } from '@/providers/vezgo/utils/callback-processor';

/**
 * VezgoConnectFlow component
 * ONLY handles UI presentation of connection status
 * All processing is done by VezgoCallback.tsx
 */
export function VezgoConnectFlow() {
  const [searchParams] = useSearchParams();
  const vezgoContext = useVezgoContext();
  
  // Extract parameters
  const success = searchParams.get('success') === 'true';
  const account = searchParams.get('account');
  const timestamp = searchParams.get('timestamp');
  
  // Only display UI based on URL parameters
  // No processing of callbacks happens here
  const showProcessingUI = success && account;
  
  // Check for stale callback flags on component mount
  useEffect(() => {
    CallbackProcessor.cleanupStaleFlags();
  }, []);
  
  // Cleanup URL parameters after a delay
  useEffect(() => {
    if (showProcessingUI) {
      logger.info('VezgoConnectFlow', 'Detected success parameters', {
        account,
        timestamp,
        callbackDetails: CallbackProcessor.getCallbackDetails()
      });
      
      // Cleanup URL parameters after 10 seconds
      const timeoutId = setTimeout(() => {
        logger.info('VezgoConnectFlow', 'Cleaning up URL parameters');
        cleanupConnectionSuccessParams();
      }, 10000);
      
      return () => clearTimeout(timeoutId);
    }
  }, [showProcessingUI, account, timestamp]);

  if (!showProcessingUI) return null;

  return (
    <CallbackProcessing 
      provider={account || 'Connected Account'}
    />
  );
}
